module.exports = __webpack_public_path__ + "img/20210731_144702.3e70c0b2.jpg";